export type PixelConfigurationErrorCode =
  | 'INVALID_PIXEL_ID'
  | 'INVALID_SETTINGS';

export class PixelConfigurationError extends Error {
  readonly code: PixelConfigurationErrorCode;

  readonly cause?: unknown;

  constructor(
    message: string,
    code: PixelConfigurationErrorCode,
    cause?: unknown
  ) {
    super(message);
    this.name = 'PixelConfigurationError';
    this.code = code;
    if (cause !== undefined) {
      this.cause = cause;
    }
  }
}
